import _ from 'lodash';
import * as ActionType from '../../core/ActionType'
import InitialState from '../../core/InitialState';


const apiReducer = (state = InitialState.apiReducer, action) => {
    if (action.type === ActionType.API_CALL_BEGIN) {
        return {
            ...state, chamadaApiEmProgresso: state.chamadaApiEmProgresso + 1,
            isLoading: true
        };

    } else if (isApiCallFinished(action.type) || action.type === ActionType.API_CALL_ERROR) {
        return {
            ...state, chamadaApiEmProgresso: state.chamadaApiEmProgresso - 1,
            isLoading: false

        };
    }

    return state;
};


function isApiCallFinished(type) {
    return _.endsWith(type, '_RESPONSE');
}


export default apiReducer;